import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import InAppMessage from "./in-app-message.js";
import { DOMUtils as dt } from "../../util/dom-utils.js";

var SlideUpMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(SlideUpMessage, _InAppMessage);

  var _super = _createSuper(SlideUpMessage);

  function SlideUpMessage(t, e, o, s, n, i, r, d, u, a, p, l, m, c, v, x, g, f, h, I, M) {
    var _this;

    _classCallCheck(this, SlideUpMessage);

    x = x || InAppMessage.ji.Wi, v = v || InAppMessage.ji.Gi, _this = _super.call(this, t, e = e || InAppMessage.TextAlignment.START, o, s, n, i, r, d, u, a, p, l, null, m, c, v, x, g, f, h, void 0, void 0, void 0, void 0, void 0, void 0, void 0, I, M);
    return _this;
  }

  _createClass(SlideUpMessage, [{
    key: "we",
    value: function we() {
      return !1;
    }
  }, {
    key: "ke",
    get: function get() {
      return InAppMessage.TextAlignment.START;
    }
  }, {
    key: "Me",
    value: function Me() {
      var t = document.createElement("span");
      return t.appendChild(document.createTextNode(this.message)), t;
    }
  }, {
    key: "Ri",
    value: function Ri(t) {
      var e = t.getElementsByClassName("ab-in-app-message")[0];
      dt.eo(e, !0, !0) || (this.slideFrom === InAppMessage.SlideFrom.TOP ? e.style.top = "0px" : e.style.bottom = "0px"), _get(_getPrototypeOf(SlideUpMessage.prototype), "Ri", this).call(this, t);
    }
  }]);

  return SlideUpMessage;
}(InAppMessage);

export { SlideUpMessage as default };
SlideUpMessage.es = InAppMessage.es.Xi;